module.exports = __webpack_public_path__ + "img/055.43f08b3e.png";